import Vue from 'vue';
import Router from 'vue-router';

import Login from '@/components/auth/Login';
import Callback from '@/components/auth/Callback';
import Country from '@/components/Country';
import Settings from '@/components/settings/Settings';
import BobLogin from '@/components/auth/BobLogin';

import Main from '@/components/Main';
import VoucherIssues from '@/components/VoucherIssues';
import Lookup from '@/components/Lookup';
import Hotwires from '../../components/hotwires/Hotwires';
import FoodSafetyIssues from '@/components/errors/FoodSafetyIssues';
import VoucherLookup from '@/components/vouchers/VoucherLookup';
import VoucherTools from '@/components/vouchers/VoucherTools';
import store from '@/store/store';
import {COUNTRYCODE} from '@/modules/constants';

Vue.use(Router);

let routerObject = {
	routes: [
		{
			path: '/',
			name: 'login',
			component: Login
		},
		{
			path: '/auth/callback',
			name: 'callback',
			component: Callback
		},
		{
			path: '/country',
			name: 'country',
			component: Country
		},
		{
			path: '/settings',
			name: 'settings',
			component: Settings
		},
		{
			path: '/home',
			name: 'home',
			component: Main
		},
		{
			path: '/voucher_issue',
			name: 'voucher_issue',
			component: VoucherIssues
		},
		{
			path: '/auth/bob',
			name: 'bob_login',
			component: BobLogin
		},
		{
			path: '/lookup',
			name: 'lookup',
			component: Lookup
		},
		{
			path: '/hotwires',
			name: 'hotwires',
			component: Hotwires
		},
		{
			path: '/food_safety',
			name: 'food_safety',
			component: FoodSafetyIssues
		},
		{
			path: '/voucher_lookup',
			name: 'voucher_lookup',
			component: VoucherLookup
		},
		{
			path: '/voucher_tools',
			name: 'voucher_tools',
			component: VoucherTools
		},
		{
			path: '*',
			redirect: '/'
		}
	]
};


let router = new Router(routerObject);

router.beforeEach((to, from, next) => {
	// ANZOPSTECH-1015 Hide hotwires for Youfoodz brand
	// ANZOPSTECH-1016 Hide food_safety for Youfoodz brand
	const hideRoutesYE = ['hotwires', 'food_safety'];
	if (store.state.country === COUNTRYCODE.YE && hideRoutesYE.includes(to.name)) {
		next('/home')
	} else {
		next()
	}
});
export default router;
